<template>
	<section id="bot-tutorials" class="mt-3 animate__animated animate__fadeIn">
		<h2>Tutorials</h2>

		<div class="row">
			<div class="col-6" :key="key" v-for="(tutorial,key) in tutorials">
				<div class="card mb-4 p-3">
					<div class="card-body">
						<h4 class="mb-3">{{ tutorial.name }}</h4>

						<p class="mb-5">{{tutorial.description}}</p>

						<video preload="metadata" muted playsinline controls class="w-100">
							<source :src="tutorial.link" type="video/mp4">
						</video>
					</div>
				</div>
			</div>
		</div>

	</section>
</template>

<script>
export default {
	name: "TutorialView",
	data() {
		return {
			tutorials: [
				{
					name: "Getting Started",
					link: "/videos/tutorials/fb_getting_started.mp4",
					description:
							"This video provides a comprehensive guide to setting up Fluxbot for the first time. It covers the initial steps needed to get your bot up and running, including installation and basic configuration.",
				},
				{
					name: "Buying Tokens",
					link: "/videos/tutorials/fb_token_buy.mp4",
					description: "Learn how to use the bot to buy Solana-based tokens with ease. This tutorial walks you through the process, from setting up your wallet to executing a successful purchase.",
				},
				{
					name: "Selling Tokens",
					link: "/videos/tutorials/fb_token_sell.mp4",
					description: "Find out how to sell your tokens through the bot. This video will guide you through the selling process, showing you how to set your selling price and complete the transaction.",
				},
				{
					name: "Transferring SOL",
					link: "/videos/tutorials/fb_transfer.mp4",
					description: "Discover how to transfer SOL between different wallets using the bot. This tutorial covers all you need to know about initiating and confirming SOL transfers.",
				},
				{
					name: "Limit Orders",
					link: "/videos/tutorials/fb_limit_order.mp4",
					description: "This video teaches you how to set limit orders using the bot, allowing you to buy or sell tokens when they reach a specific price point.",
				},
				{
					name: "Dollar Cost Averaging",
					link: "/videos/tutorials/fb_dca.mp4",
					description: "Learn how to implement a dollar-cost averaging strategy with your investments using the bot. This video explains the concept and shows you how to set it up.",
				},
				{
					name: "Mirror/Copy Trader",
					link: "/videos/tutorials/fb_copy_trader.mp4",
					description: "Find out how to mirror the trading strategies of successful traders through. This tutorial covers how to select a trader to mirror and how to allocate your funds for this strategy.",
				},
				{
					name: "Unwrapping SOL",
					link: "/videos/tutorials/fb_unwrap.mp4",
					description: "Learn the steps to unwrap your SOL tokens using the bot. This video will guide you through the unwrapping process, allowing you to use your SOL in different ways.",
				},
				{
					name: "Settings & Security",
					link: "/videos/tutorials/fb_password.mp4",
					description:
							"This video focuses on how to stay secure while using the bot and customize its settings. Learn about the security measures you can take and how to tailor the bot to your needs.",
				}
			],
		}
	}
}
</script>

<style scoped>
p {
	min-height: 80px;
}
</style>